import React from "react";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonPropsWithoutRef } from "react-html-props";
import styled from "styled-components";

const ModalClose = (props: Props) => (
  <ModalCloseButton {...props}>
    <FontAwesomeIcon size="lg" icon={faTimes} />
  </ModalCloseButton>
);

interface Props extends ButtonPropsWithoutRef {
  // Override these so that they are required.
  onClick: () => void;
  "aria-label": string;
}

const ModalCloseButton = styled.button`
  background: none;
  border: none;
  position: absolute;
  top: 0;
  right: 0;
  padding: 1rem;
  color: ${({ theme }) => theme.colors.text};
`;

export default ModalClose;
